import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class PMSCompanyService {
    static getAllCompanies(pharmacyId, data) {
        return axios.get(`${URL.GET_ALL_PHARMACY_COMPANIES}/${pharmacyId}`, {
            ...PMSCompanyService.getAuthHeader(),
            params: data
        });
    }

    static getCompanyById(id, pharmacyId) {
        return axios.get(`${URL.GET_PHARMACY_COMPANY_BY_ID}/${id}/${pharmacyId}`, PMSCompanyService.getAuthHeader());
    }

    static addCompany(data, pharmacyId) {
        return axios.post(`${URL.POST_PHARMACY_COMPANY}/${pharmacyId}`, data, PMSCompanyService.getAuthHeader());
    }

    static updateCompany(data, id, pharmacyId) {
        return axios.put(`${URL.UPDATE_PHARMACY_COMPANY}/${id}/${pharmacyId}`, data, PMSCompanyService.getAuthHeader());
    }

    static deleteCompany(id, pharmacyId) {
        return axios.delete(`${URL.DELETE_PHARMACY_COMPANY}/${id}/${pharmacyId}`, PMSCompanyService.getAuthHeader());
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = {headers: {"Authorization": `Bearer ${accessToken}`}}
        return options;
    }

}